var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VueDraggable',{attrs:{"list":_vm.list,"handle":".handle","group":"tasks","tag":_vm.tag,"value":_vm.list,"noTransitionOnDrag":_vm.noTransitionOnDrag},on:{"change":_vm.onChange}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }